import React from 'react';
import image from '../images/s_text_image.png';
import style from '../css/Component2.module.css';
import useLocation from './useLocation';  

function Five() {
	const location = useLocation();  

	return (
		<div className={style.container}>
			<div className={style.box}>
				<h1 className={style.header}>How Professional Are We?</h1>
				<p className={style.desc}>
					HomeTech Repairs, customer satisfaction is our top priority.
					Professionalism is our forte, and we ensure all your requirements are
					perfectly met. Our platform allows you to easily filter service
					centers based on your location and the type of service you need.
					Simply enter your location and requirements, and get instant results.
					With our reliable services, you can connect with the best repair
					experts in {location} in just a few clicks.
				</p>
			</div>

			<img src={image} alt="" className={style.image} />
		</div>
	);
}

export default Five;
